// extracted by mini-css-extract-plugin
module.exports = {"absolute":"CertificatesMobileMenu_absolute__sixnc"};